import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Clock, TrendingDown, FolderKanban, Eye } from 'lucide-react';
import { motion } from 'framer-motion';

export const Advantages = () => {
  const { t } = useLanguage();

  const advantages = [
    {
      icon: Clock,
      title: t('advantage_time'),
      description: t('advantage_time_desc'),
    },
    {
      icon: TrendingDown,
      title: t('advantage_cost'),
      description: t('advantage_cost_desc'),
    },
    {
      icon: FolderKanban,
      title: t('advantage_org'),
      description: t('advantage_org_desc'),
    },
    {
      icon: Eye,
      title: t('advantage_vision'),
      description: t('advantage_vision_desc'),
    },
  ];

  const fadeUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.5, ease: 'easeOut' }
  };

  return (
    <section id="advantages" className="py-16 md:py-20 bg-white" data-testid="advantages-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <motion.div 
          {...fadeUp}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3 tracking-tight" data-testid="advantages-title">
            {t('advantages_title')}
          </h2>
          <p className="text-base md:text-lg text-slate-600 max-w-2xl mx-auto">
            {t('advantages_subtitle')}
          </p>
        </motion.div>

        {/* Advantages Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {advantages.map((advantage, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="text-center group"
              data-testid={`advantage-card-${index}`}
            >
              <div className="w-16 h-16 mx-auto rounded-2xl bg-blue-50 flex items-center justify-center mb-6 group-hover:bg-blue-100 transition-colors">
                <advantage.icon className="w-8 h-8 text-blue-600" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                {advantage.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {advantage.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
